import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import Toast from "vue-toastification"
import "vue-toastification/dist/index.css"
import { initCriticalPreloads, setupIntelligentPrefetching, addPerformanceObserver } from '@/utils/preloader'
import { initAnalytics, trackCoreWebVitals, setupSearchTracking } from '@/utils/analytics'

import App from './App.vue'
import router from './router'

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(Toast, {
  transition: "Vue-Toastification__bounce",
  maxToasts: 5,
  newestOnTop: true,
  position: "top-right",
  timeout: 5000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: "button",
  icon: true,
  rtl: false
})

app.mount('#app')

// Initialize performance optimizations and analytics
document.addEventListener('DOMContentLoaded', () => {
  initCriticalPreloads()
  setupIntelligentPrefetching()
  addPerformanceObserver()
  
  // Initialize analytics and tracking
  initAnalytics()
  trackCoreWebVitals()
  setupSearchTracking()
})
